export const STATUS_KEY = "CurrentVoyageStatus"
export const LAST_DEPARTURE_TIME_KEY = "LastDepartureTime"
export const CURRENT_PARK_TIME_KEY = "CurrentParkTime"
export const MOVING = "Moving"
export const STOPPED = "Stopped"